<div class="router-business">
    <div class="business-panel-container page-panel">
        <div>
            <app-info-business [business]="business" [description]="description" [idBusiness]="businessSelect?.id" [owner]="owner" *ngIf="tabSelected !== 2"></app-info-business>
            <app-help-business *ngIf="tabSelected === 2"></app-help-business>
        </div>
    </div>
</div>
